import { NextFunction, Request, Response } from "express";
import { inject, injectable } from "inversify";
import * as request from "request";
import * as url from "url";
import { IErrorReporter } from "../domain/interfaces/error-reporter.interface";
import { DI } from "../infrastructure/di";
import { BOBEnvironment } from "./bob-environment";

@injectable()
export class Passthrough {

	@inject(DI.ERROR_REPORTER) private errorReporter: IErrorReporter;

	public getHandler(): (req: Request, res: Response, next: NextFunction) => Promise<void> {

		return async (req: Request, res: Response, next: NextFunction) => {

			if (this.isPassthroughRequest(req)) {

				const forwardUrl = this.getForwardUrl(req);
				const requestConfig = this.getRequestConfig(forwardUrl);

				req.pipe(request(requestConfig, (e: any) => {

					if (e) {

						this.errorReporter.error(req, {error: e});
						// tslint:disable-next-line
						console.error(`${req.method} - '${req.url}' - Passthrough failed`);
						res.status(504).end();
					}
				})).pipe(res);
			} else {

				next();
			}
		};
	}

	public isPassthroughRequest(req: Request): boolean {

		return req.method !== "GET" || this.isAcceptingHtml(req) === false;
	}

	public isAcceptingHtml(req: Request): boolean {

		if (req.headers.accept && req.headers.accept.includes("html")) {
			return true;
		}

		const urlParts = req.path.split(".");

		if (urlParts.length === 1) {
			return true;
		}

		return urlParts.pop() === "html";
	}

	public getForwardUrl(req: Request): string {

		const reqUrl = url.parse(req.url);

		return url.format({
			pathname: reqUrl.pathname,
			search: reqUrl.search,
			hostname: BOBEnvironment.getCorrectHostnameByRequest(req),
			protocol: process.env.BOB_ORIGIN_PROTOCOL,
			port: process.env.BOB_ORIGIN_PORT
		});
	}

	public getRequestConfig(forwardUrl: string): any {

		const requestConfig = {
			url: forwardUrl,
			timeout: 5000,
			followRedirect: false
		};

		if (BOBEnvironment.ignoreSSLVerification()) {

			requestConfig["strictSSL"] = false;
		}

		return requestConfig;
	}
}
